import { TFunction } from 'i18next';

import uiHelpers from '../../../helpers/ui.helper';
import { PriceDataPoint, ProbabilityData } from '../../../types';
import {
  DataSetSeriesGenerator,
  getDefaultToolptipFormatter,
  PriceViewerSeries,
} from './base';

class Probability extends DataSetSeriesGenerator {
  yAxisFormatter = uiHelpers.formatPercentage;
  isSeparateFromPriceChart = true;
  height = 240;
  probabilityData: ProbabilityData;
  strokeColors = ['#5488B5', '#5CA24B', '#F19B4F', '#BB433C', '#0D0D0D'];

  constructor(t: TFunction, probabilityData: ProbabilityData) {
    super(t);
    this.probabilityData = probabilityData;
  }

  getChartName(): string {
    return this.t('Probability');
  }

  getSeries(dataPoints: ReadonlyArray<PriceDataPoint>): PriceViewerSeries[] {
    const dates = dataPoints.map(({ date }) => date);
    const earliestDate = dates[0] as string;
    const solidLines = [[], [], [], []];
    const dashedLines = [[], [], [], []];
    const {
      data: prob,
      dashedData: dashedProb,
      thresholds,
    } = this.probabilityData;
    for (let i = prob.length - 1; i >= 0; i--) {
      const date = prob[i].date.split('T')[0];
      for (const key in [0, 1, 2, 3]) {
        solidLines[key].unshift([date, prob[i][`v${key}`]]);
      }
      if (date === earliestDate) {
        break;
      }
    }
    for (let i = dashedProb.length - 1; i >= 0; i--) {
      const date = dashedProb[i].date.split('T')[0];
      for (const key in [0, 1, 2, 3]) {
        dashedLines[key].unshift([date, dashedProb[i][`v${key}`]]);
      }
      if (date === earliestDate) {
        break;
      }
    }
    return [
      ...solidLines.map((probData, index) => {
        return {
          name: `${thresholds[index] * 100}%${this.t('Probability')}(${this.t(
            'solid'
          )})`,
          echartSeries: {
            type: 'line',
            data: probData,
            symbol: 'none',
            lineStyle: {
              color: this.strokeColors[index],
              width: 2,
            },
            emphasis: {
              lineStyle: {
                width: 2,
              },
            },
          },
          tooltipFormatter: getDefaultToolptipFormatter('2d', 'percentage', {
            keyColor: this.strokeColors[index],
          }),
        };
      }),
      ...dashedLines.map((probData, index) => {
        return {
          name: `${thresholds[index] * 100}%${this.t('Probability')}(${this.t(
            'dashed'
          )})`,
          echartSeries: {
            type: 'line',
            data: probData,
            symbol: 'none',
            lineStyle: {
              color: this.strokeColors[index],
              type: 'dashed',
              width: 2,
            },
            emphasis: {
              lineStyle: {
                width: 2,
              },
            },
          },
          tooltipFormatter: getDefaultToolptipFormatter('2d', 'percentage', {
            keyColor: this.strokeColors[index],
          }),
        };
      }),
    ];
  }
}

export default Probability;
